<template>
  <layout-side-menu-content>
    <settings-caption>
      データ初期設定
    </settings-caption>

    <caution-message />
    <button-init />
  </layout-side-menu-content>
</template>

<script>
import LayoutSideMenuContent from '@/lib/Layout/SideMenuContent'
import SettingsCaption from '@/components/Settings/Caption'
import CautionMessage from './CautionMessage'
import ButtonInit from './ButtonInit'

export default {
  components: {
    LayoutSideMenuContent,
    SettingsCaption,
    CautionMessage,
    ButtonInit
  }
}
</script>
